// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35LSg","icon":"styles_icon__1lEif"};